"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('generalOptions', {
    supportedCultures: [],
    supportedShortDateFormats: [],
    supportedShortTimeFormats: [],
    supportedTimeZones: [],
    selectedLocale: null,
    shouldRenameDefaultFolders: true,
    selectedDateFormat: null,
    selectedTimeFormat: null,
    selectedTimeZone: null,
    hasUserChangedLanguage: false,
});
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/data/store/store.js
// module id = 2651
// module chunks = 2